import type { DetectedFace } from '../types';
import type { FrameSize } from './framing';

export interface ViewportBox {
  left: number;
  top: number;
  width: number;
  height: number;
}

/**
 * Project a face box from source-frame pixels onto the on-screen preview.
 * The preview renders with `object-cover` (scale to fill, center-crop) and is
 * mirrored for the selfie convention — both transforms are applied here so
 * the overlay tracks the face the user actually sees.
 */
export function projectBoxToCover(
  face: DetectedFace,
  frame: FrameSize,
  viewport: FrameSize,
  mirrored = true,
): ViewportBox | null {
  if (frame.width <= 0 || frame.height <= 0 || viewport.width <= 0 || viewport.height <= 0) {
    return null;
  }
  const scale = Math.max(viewport.width / frame.width, viewport.height / frame.height);
  const offsetX = (frame.width * scale - viewport.width) / 2;
  const offsetY = (frame.height * scale - viewport.height) / 2;

  let left = face.x * scale - offsetX;
  const top = face.y * scale - offsetY;
  const width = face.width * scale;
  const height = face.height * scale;
  if (mirrored) left = viewport.width - (left + width);

  return { left, top, width, height };
}
